import moment from 'moment';

import { SalesStage } from '../../../../Model/Lead';
import ContractsManager from '../../../../components/ContractsManager';
import FollowUps from '../FollowUps';
import LeadsContacted from '../LeadsContacted';
import PaymentPending from '../PaymentPending';

import ISDashboardTabs from './tabs';
import {
  StyledFollowUpsIcon,
  StyledPaymentPendingIcon,
  StyledContractsManagerIcon,
  StyledLeadsContactedIcon,
} from './styles';
import texts from './texts.json';

const isLeadsContactedLead = ({ salesStage, claimedAt }) => (
  salesStage !== SalesStage.FOLLOW_UP
  && salesStage !== SalesStage.PAYMENT_PENDING
  && (claimedAt && moment(claimedAt.toDate()).isAfter(moment().subtract(24, 'hours')))
);

const ISDashboardTabsConfig = {
  [ISDashboardTabs.FOLLOW_UP]: {
    label: texts.tabLabels[ISDashboardTabs.FOLLOW_UP],
    icon: StyledFollowUpsIcon,
    component: FollowUps,
    count: 0,
  },
  [ISDashboardTabs.PAYMENT_PENDING]: {
    label: texts.tabLabels[ISDashboardTabs.PAYMENT_PENDING],
    icon: StyledPaymentPendingIcon,
    component: PaymentPending,
    count: 0,
  },
  [ISDashboardTabs.CONTRACTS_MANAGER]: {
    label: texts.tabLabels[ISDashboardTabs.CONTRACTS_MANAGER],
    icon: StyledContractsManagerIcon,
    component: ContractsManager,
    count: 0,
  },
  [ISDashboardTabs.LEADS_CONTACTED]: {
    label: texts.tabLabels[ISDashboardTabs.LEADS_CONTACTED],
    icon: StyledLeadsContactedIcon,
    component: LeadsContacted,
    count: 0,
  },
};

const isDashboardTabsFilterChecks = {
  [ISDashboardTabs.FOLLOW_UP]: ({ salesStage }) => salesStage === SalesStage.FOLLOW_UP,
  [ISDashboardTabs.LEADS_CONTACTED]: isLeadsContactedLead,
};

export default ISDashboardTabsConfig;
export {
  isDashboardTabsFilterChecks,
};
